import React, { Component } from "react";
import styled from "styled-components";
import Layout from "./Layout";

class ContentCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="ContentCarousel" />
        {this.state.hover && <DivHelp>Content Carousel</DivHelp>}
      </DivHover>
    );
  }
}

// const ContentCarousel = props => <Layout {...props} type="ContentCarousel" />;

export default ContentCarousel;

export const DivHover = styled.div`
  z-index: 201;
  position: relative;
  width: 100%;
  outline: 0px solid #00bcd4;
  &:hover {
    z-index: 251;
    outline: 2px solid #ff9900;
    cursor: pointer;
  }
`;

export const DivHelp = styled.div`
  font-family: Open Sans, sans-serif;
  position: absolute;
  bottom: -20px;
  left: 50%;
  background-color: #ff9900;
  color: #fff;
  display: block;
  z-index: 251;
  font-size: 12px;
  line-height: 20px;
  padding: 0 10px;
  height: 20px;
`;



// WEBPACK FOOTER //
// ./src/editor/layout/components/ContentCarouselContainer.js